import { useNavigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { getOneInternalInvoice } from 'api/Billing';

export const useOneInternalInvoice = ({ params = {}, options = {}, dependencies = [] }) => {
  const navigate = useNavigate();

  return useQuery(
    ['internal_invoice', ...dependencies],
    () => getOneInternalInvoice(navigate, params),
    { refetchOnMount: false, refetchOnWindowFocus: false, ...options }
  );
};
